import PropType from 'prop-types';
import React, { useEffect, useState } from 'react';

import { confirmPayment, initiatePayment as initiatePaymentAPI } from '../../services/services';
import { checkRazorPayValidation, validatePayload } from '../../utils/checkValidation';
import { API_ERROR_CODES, PAYMENT_MODE, SPM_ERROR_STATUS, SPM_STATE } from '../../utils/consts';
import { loadCDN } from '../../utils/loadCDN';
import InsufficientMiles from '../InsufficientMiles';
import OTPVerification from '../OTPVerification';

function SPM(props) {
  let paymentFailure = null;

  const [showOTPScreen, setShowOTPScreen] = useState(false);
  const [showInsufficientMilesPopup, setShowInsufficientMilesPopup] = useState(false);
  const [initiatePaymentRes, setInitiatePaymentRes] = useState();
  const [apiErr, setApiErr] = useState();

  const { payload, hideInsufficientMilesPopup, loadRazorpay } = props;

  const createSPMErrorObj = (errorCode, state, errorMsg, msg, othersData) => {
    let errorObject = {
      errorCode: errorCode || '',
      state: state || '',
      errorMsg: errorMsg || '',
      msg: msg || '',
      status:
        errorCode === API_ERROR_CODES.LOGIN_REQUIRED ? SPM_ERROR_STATUS.LOGIN_REQUIRED : SPM_ERROR_STATUS.NETWORK_ERROR,
      ...othersData,
    };
    if (errorCode === API_ERROR_CODES.MILES_VALIDATION_ERROR) {
      errorObject.status = SPM_ERROR_STATUS.INSUFFICENT_MILES;
    }
    return errorObject;
  };

  useEffect(() => {
    if (loadRazorpay) {
      initiatePayment();
    } else {
      let spmerror = createSPMErrorObj('', SPM_STATE.SPM_INITIATE, 'Something went wrong', 'Something went wrong', {
        status: SPM_ERROR_STATUS.NOT_VALID_OBJECT,
      });
      payload.error(spmerror);
    }
  }, [props]);

  const initiatePayment = () => {
    if (!validatePayload(payload)) {
      let spmerror = createSPMErrorObj('', SPM_STATE.SPM_INITIATE, 'Not valid object', 'Not valid object', {
        status: SPM_ERROR_STATUS.NOT_VALID_OBJECT,
      });
      payload.error(spmerror);
      return;
    }
    let initiatePayload = {
      paymentId: payload ? payload.paymentId : null,
      product: payload ? payload.product : null,
      paymentMode: payload ? payload.paymentMode : null,
      supportsOptionalOTP: true, // Mandtory field. Backend have some logic based on this prop.
    };
    if (payload.paymentMode === PAYMENT_MODE.MILES) {
      initiatePayload.miles = payload.paymentObject.interMiles;
    } else {
      initiatePayload.amount = payload.paymentObject.amount;
      initiatePayload.currency = payload.paymentObject.currency;
    }
    let initiatePaymentResult = {};
    initiatePaymentAPI(initiatePayload)
      .then(async res => {
        if (res.code !== 600) {
          setApiErr({ ...res, state: SPM_STATE.SPM_INITIATE });
          /**
           * Show insuffiecient miles popup
           * if API throws insuffiecient miles error and hideInsufficientMilesPopup is false
           * */
          if (res.errorCode === API_ERROR_CODES.MILES_VALIDATION_ERROR && !hideInsufficientMilesPopup) {
            setShowInsufficientMilesPopup(true);
          } else {
            let spmerror = createSPMErrorObj(res.errorCode, SPM_STATE.SPM_INITIATE, res.errorMsg, res.msg, {
              status: res.status,
            });
            payload.error(spmerror);
          }
        } else {
          initiatePaymentResult = res.data;
          setInitiatePaymentRes(initiatePaymentResult);
          if (initiatePayload && initiatePayload.paymentMode === PAYMENT_MODE.MILES) {
            if (initiatePaymentResult.skipOTP) {
              // skip OTP case.
              handleSuccess(initiatePaymentResult);
            } else {
              setShowOTPScreen(true);
            }
          } else {
            let paymentData = {
              product: payload ? payload.product : null,
              paymentMode: payload ? payload.paymentMode : null,
              paymentId: payload ? payload.paymentId : null,
              paymentObject: {
                amount: payload.paymentObject ? payload.paymentObject.amount * 100 : null,
                currency: payload.paymentObject ? payload.paymentObject.currency : null,
                description: payload.paymentObject ? payload.paymentObject.description : null,
                image: payload.paymentObject ? payload.paymentObject.image : null,
                interMiles: payload.paymentObject ? payload.paymentObject.interMiles : null,
                retry: false,
                order_id: initiatePaymentResult ? initiatePaymentResult.razorpayOrderId : null,
                key: initiatePaymentResult ? initiatePaymentResult.razorpayClientId : null,
                name: payload.paymentObject ? payload.paymentObject.name : null,
                prefill: {
                  name:
                    payload.paymentObject && payload.paymentObject.prefill ? payload.paymentObject.prefill.name : null,
                  contact:
                    payload.paymentObject && payload.paymentObject.prefill
                      ? payload.paymentObject.prefill.contact
                      : null,
                  email:
                    payload.paymentObject && payload.paymentObject.prefill ? payload.paymentObject.prefill.email : null,
                },
                handler: result => {
                  handleSuccess(result);
                },
                modal: {
                  ondismiss: function () {
                    let checkOutWindowClose = true;
                    handleFailure(checkOutWindowClose);
                  },
                },
              },
              success: payload ? payload.success : null,
              error: payload ? payload.error : null,
            };

            if (checkRazorPayValidation(paymentData)) {
              await loadCDN('https://checkout.razorpay.com/v1/checkout.js');
              let rzp = window.Razorpay(paymentData.paymentObject);
              rzp.open();
              rzp.on('payment.failed', function (response) {
                paymentFailure = response;
              });
            } else {
              let spmerror = createSPMErrorObj('', SPM_STATE.SPM_INITIATE, 'Not valid object', 'Not valid object', {
                status: SPM_ERROR_STATUS.NOT_VALID_OBJECT,
              });
              payload.error(spmerror);
            }
          }
        }
      })
      .catch(err => {
        if (err) {
          let spmerror = createSPMErrorObj(
            err?.response?.data?.data?.code,
            SPM_STATE.SPM_INITIATE,
            err?.response?.data?.data?.message,
            err?.message
          );
          payload.error(spmerror);
        }
      });
  };

  const onOTPSuccess = () => {
    setShowOTPScreen(false);
    handleSuccess(initiatePaymentRes);
  };

  const onOTPScreenClose = () => {
    setShowOTPScreen(false);
    let spmerror = createSPMErrorObj(
      '',
      SPM_STATE.SPM_INITIATE,
      'Payment cancelled by user',
      'Payment cancelled by user',
      { status: SPM_ERROR_STATUS.TRANSACTION_CANCELLED }
    );
    payload.error(spmerror);
  };

  const handleSuccess = req => {
    let config = {
      paymentId: payload ? payload.paymentId : null,
      product: payload ? payload.product : 'PAYWALL',
      paymentMode: payload ? payload.paymentMode : null,
    };
    if (payload.paymentMode === PAYMENT_MODE.MILES) {
      config.RewardBookingStoreEntities = {
        RewardBookingStore: [
          {
            TotalMiles: req.miles,
          },
        ],
      };
    } else {
      config.razorpayPaymentId = req.razorpay_payment_id;
      config.razorpayOrderId = req.razorpay_order_id;
      config.razorpaySignature = req.razorpay_signature;
    }

    confirmPayment(config)
      .then(res => {
        if (res.code !== 600) {
          setApiErr({ ...res, state: SPM_STATE.SPM_CONFIRM });
          if (res.errorCode === API_ERROR_CODES.MILES_VALIDATION_ERROR && !hideInsufficientMilesPopup) {
            setShowInsufficientMilesPopup(true);
          } else {
            let spmerror = createSPMErrorObj(res.errorCode, SPM_STATE.SPM_CONFIRM, res.errorMsg, res.msg, {
              status: res.status,
            });
            payload.error(spmerror);
          }
        } else {
          payload.success(res);
        }
      })
      .catch(err => {
        if (err) {
          let spmerror = createSPMErrorObj(
            err?.response?.data?.data?.code,
            SPM_STATE.SPM_CONFIRM,
            err?.response?.data?.data?.message,
            err?.message
          );
          payload.error(spmerror);
        }
      });
  };

  const handleFailure = res => {
    if (paymentFailure && res) {
      let spmerror = createSPMErrorObj('', '', paymentFailure.error.description, paymentFailure.error.description, {
        status: SPM_ERROR_STATUS.PAYMENT_FAILED,
      });
      payload.error(spmerror);
    } else {
      let spmerror = createSPMErrorObj(
        '',
        SPM_STATE.SPM_INITIATE,
        'Payment cancelled by user',
        'Payment cancelled by user',
        { status: SPM_ERROR_STATUS.TRANSACTION_CANCELLED }
      );
      payload.error(spmerror);
    }
  };

  const handleInsufficientMilePopupClose = action => {
    setShowInsufficientMilesPopup(false);
    let spmerror = createSPMErrorObj(apiErr?.errorCode, apiErr?.state, apiErr?.errorMsg, apiErr?.msg, {
      status: apiErr?.status,
      action: action,
    });
    payload.error(spmerror);
  };

  if (showOTPScreen) {
    return (
      <OTPVerification
        initiatePaymentRes={initiatePaymentRes}
        closePopup={onOTPScreenClose}
        onOTPSuccess={onOTPSuccess}
      />
    );
  } else if (showInsufficientMilesPopup) {
    return <InsufficientMiles closePopup={handleInsufficientMilePopupClose} />;
  } else {
    return <></>;
  }
}

SPM.propTypes = {
  payload: PropType.object,
  hideInsufficientMilesPopup: PropType.bool,
  loadRazorpay: PropType.bool,
};

export default SPM;
